import { render, staticRenderFns } from "./ProductSortFilter.vue?vue&type=template&id=e1f2a420"
import script from "./ProductSortFilter.vue?vue&type=script&lang=js"
export * from "./ProductSortFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductSortFilter.vue?vue&type=style&index=0&id=e1f2a420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports